import { GLOBAL_OBJ as s } from "./chunk850.js";
const c = 1e3;
function u() {
  return Date.now() / c;
}
function f() {
  const { performance: n } = s;
  if (!n || !n.now)
    return u;
  const t = Date.now() - n.now(), i = n.timeOrigin == null ? t : n.timeOrigin;
  return () => (i + n.now()) / c;
}
const p = f();
(() => {
  const { performance: n } = s;
  if (!n || !n.now)
    return;
  const t = 3600 * 1e3, i = n.now(), e = Date.now(), r = n.timeOrigin ? Math.abs(n.timeOrigin + i - e) : t, m = r < t, o = n.timing && n.timing.navigationStart, a = typeof o == "number" ? Math.abs(o + i - e) : t, g = a < t;
  return m || g ? r <= a ? n.timeOrigin : o : e;
})();
export {
  u as dateTimestampInSeconds,
  p as timestampInSeconds
};
